import ImageZoom from 'js-image-zoom';

let imgZoom: ImageZoom | null = null;
let restoreZoomStyles: (() => void) | null = null;

function killZoom() {
  if (imgZoom) {
    imgZoom.kill();
    imgZoom = null;
    restoreZoomStyles?.();
    restoreZoomStyles = null;
  }
}

// Rebind to the fresh gallery nodes after a colourway swap.
const initImageZoom = () => {
  killZoom();

  // The opted-in product gallery uses a native, zoomable dialog and leaves
  // browser pinch zoom available. Excluded pages retain their original zoom.
  if (document.querySelector('main[data-product-image-lightbox]')) return;

  const imgSlides = [...document.querySelectorAll('.single-product__gallery-zoom')] as HTMLElement[];
  const thumbs = [...document.querySelectorAll('.js-product-gallery-thumb')];

  imgSlides.forEach((slide) => {
    slide.addEventListener('click', () => {
      if (imgZoom) {
        killZoom();
        return;
      }

      const image = slide.querySelector('img');
      if (!image || !image.complete || !image.naturalWidth || !image.naturalHeight) return;
      const cell = slide.closest('.js-slide');
      if (cell && !cell.classList.contains('is-selected')) return;
      const bounds = image.getBoundingClientRect();
      if (bounds.width <= 0 || bounds.height <= 0) return;

      const position = slide.style.position;
      const width = image.style.width;
      const height = image.style.height;
      // js-image-zoom 0.7 needs explicit rendered dimensions. It also writes a
      // relative position which must not replace the gallery's absolute layout.
      imgZoom = new ImageZoom(slide, {
        width: bounds.width,
        height: bounds.height,
        zoomPosition: 'original',
      });
      slide.style.position = position;
      const zoomedImage = slide.querySelector<HTMLElement>('.js-image-zoom__zoomed-image');
      if (zoomedImage) {
        zoomedImage.style.backgroundImage = `url(${JSON.stringify(image.currentSrc || image.src)})`;
      }
      restoreZoomStyles = () => {
        slide.style.position = position;
        image.style.width = width;
        image.style.height = height;
      };
    });
  });

  thumbs.forEach((thumb) => thumb.addEventListener('click', killZoom));
};

// Swipe and variant changes can select a slide without clicking a thumbnail.
document.addEventListener('product:image-change', killZoom);
document.addEventListener('DOMContentLoaded', initImageZoom);
document.addEventListener('product:swap', initImageZoom);
